
import styled from "styled-components"
import TopbarMenulerSm from "../topbarMenuler/TopbarMenulerSm"
import { useSelector } from "react-redux"
import TopbarTop from "../topbarTop/TopbarTop"

const Container = styled.div`
  margin-left: ${({sidebarState}) => sidebarState === "sm-icon" ? "85px" : sidebarState === "wide" ? "300px" : sidebarState === "hidden" && "0"};
  transition: .5s width;
  width: ${({sidebarState}) => sidebarState === "sm-icon" ? "calc(100% - 85px)" : sidebarState === "wide" ? "calc(100% - 300px)" : sidebarState === "hidden" && "100%"};
  position: fixed;
  top: 0;
  z-index: 10;
  background-color: ${({ theme }) => theme.mainBgColor};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  @media (max-width: 850px) {
    margin-left: 0 !important;
    width: 100% !important;
  }

`


const TopbarSm = () => {

  const {sidebarState} = useSelector(state => state.layout)

  return (
    <Container sidebarState={sidebarState}>
      <TopbarTop />
      <TopbarMenulerSm/>
    </Container>
  )
}

export default TopbarSm